export const BELOW_FREE_DELIVERY_INFO_TEST_ID = {
  belowFree: 'below-free-delivery-banner',
  addMore: 'add-more-delivery-minimum-banner',
};
